<template>
    <div>
        <div class="mt-30px">
            <v-divider class="border-2 grey lighten-1" />
            <div class="py-10px py-md-6px">
                <v-row align="center" class="row--small">
                    <v-col cols="12" md="auto">
                        <div class="font-size-14">
                            검색된 상품: <b class="primary--text">{{ summary.totalCount.format() }}</b
                            >개
                        </div>
                    </v-col>
                    <v-spacer />
                    <v-col cols="12" md="auto">
                        <v-select v-model="sort" :items="sortItems" item-text="text" value="value" outlined hide-details @input="setQuery(sort)" />
                    </v-col>
                </v-row>
            </div>
            <v-divider class="grey lighten-1" />
        </div>

        <div class="py-20px py-md-30px">
            <v-row>
                <v-col v-for="product in products" :key="product._id" cols="6" md="3" class="cursor-pointer" @click="go(product._id)">
                    <v-img :src="setImgSrc(product.thumb)" width="100%" :aspect-ratio="1 / 1" contain class="mx-auto">
                        <div v-if="isDiscountedByPercent(product)" class="d-flex justify-end pa-1">
                            <v-sheet rounded="circle" width="50" color="red">
                                <v-responsive :aspect-ratio="1 / 1">
                                    <div class="h-100 d-flex justify-center align-center text-center font-size-12 font-weight-bold white--text">
                                        {{ product.discountAmount }}% <br />
                                        할인
                                    </div>
                                </v-responsive>
                            </v-sheet>
                        </div>
                    </v-img>
                    <div class="mt-4 text-center grey--text text--darken-4">
                        <div class="font-size-18 font-size-md-20 font-weight-medium text-truncate">{{ product.name }}</div>
                        <!-- 소비자가 -->
                        <s class="d-flex align-center justify-center grey--text mt-md-1">
                            <div v-if="isDiscounted(product)" class="font-size-12 font-size-md-14">{{ `${(product?.costPrice || 0).format()}원` }}</div>
                        </s>
                        <!-- 판매가 -->
                        <div class="d-flex align-center justify-center primary--text">
                            <span class="font-size-16 font-size-md-18 font-weight-bold">
                                {{ `${(product?.salePrice || 0).format()}` }}
                            </span>
                            <small class="font-size-14 font-weight-medium ml-1">원</small>
                        </div>

                        <v-layout wrap justify-center class="mt-2 mr-n1">
                            <v-flex v-if="product?.isRecommend" shrink class="pr-1"><v-chip color="#FA647D" dark x-small>추천</v-chip></v-flex>
                            <v-flex v-if="product?.isNewly" shrink class="pr-1"><v-chip color="#FFAE00" dark x-small>신상품</v-chip></v-flex>
                            <v-flex v-if="product?.isPopular" shrink class="pr-1"><v-chip color="#32C081" dark x-small>인기</v-chip></v-flex>
                            <v-flex v-if="product?.isBest" shrink class="pr-1"><v-chip color="#1AB5BB" dark x-small>베스트</v-chip></v-flex>
                        </v-layout>
                    </div>
                </v-col>
            </v-row>
        </div>
        <v-divider class="border-2 grey lighten-1" />

        <div class="mt-30px mt-md-40px">
            <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="(page) => $router.push({ query: { ...$route.query, page } })" color="primary" />
        </div>
        <!-- <kcp-cert ref="kcpCert" /> -->
    </div>
</template>


<script>
import api from "@/api";
// import KcpCert from "@/components/plugins/kcp/kcp-cert.vue";
export default {
    components: {
        // KcpCert,
    },
    data() {
        return {
            sort: this.$route.query?.sort || null,
            limit: 20,
            sortItems: [
                { text: ":: 순서선택 ::", value: null },
                { text: "최근등록순", value: "byLatest" },
                { text: "인기순", value: "byPopular" },
                { text: "낮은가격순", value: "byLowPrice" },
                { text: "높은가격순", value: "byHighPrice" },
            ],

            products: [],
            summary: { totalCount: 0 },
        };
    },
    computed: {
        page() {
            return +this.$route.query?.page || 1;
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit);
        },
        params() {
            let { ...query } = this.$route.query;
            return query;
        },
        scope() {
            return this.$store.state.scope;
        },
        refreshToken() {
            return this.$store.state.refreshToken;
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            let { products, summary } = await api.v1.dshop.products.gets({
                headers: { limit: this.limit, skip: this.skip },
                params: this.params,
            });

            this.products = products;
            this.summary = summary;
        },
        go(_product) {
            this.$router.push({ path: `/dshop/products/${_product}`, query: { _category: this.$route.query?._category } });
            // this.certificate().then(() => this.$router.push(`./products/${_product}`));
            // this.certificate().then(() => this.$router.push({ path: `/dshop/products/${_product}`, query: { _category: this.$route.query?._category } }));
        },
        // certificate() {
        //     return new Promise((resolve, reject) => {
        //         if (this.scope?.includes?.("cert")) resolve();
        //         else {
        //             this.$refs.kcpCert.$off();
        //             this.$refs.kcpCert.$on("input", async ({ _cert }) => {
        //                 await this.$store.dispatch("refresh", { refreshToken: this.refreshToken, _cert });
        //                 resolve();
        //             });

        //             this.$refs.kcpCert.open();
        //         }
        //     });
        // },
        setImgSrc(src) {
            // return `http://dev-giftcard.uxi.kr/${src}`;
            // return `https://dev-giftcard.uxi.kr/${src}`;
            return `https://daehanbooksgiftcard.com/${src}`;
        },
        isDiscounted(product) {
            return product?.costPrice !== product?.salePrice;
        },
        isDiscountedByPercent(product) {
            return this.isDiscounted(product) && product.discountAmount && product.discountUnit === "percent";
        },
        setQuery(sort) {
            let { ...query } = this.params;
            query.sort = sort;

            if (!query?.sort) delete query.sort;
            if (!query?._category) delete query._category;
            if (!query?.searchValue) {
                delete query.searchValue;
                delete query.searchKey;
            }

            // this.page = 1;
            this.$router.push({ query });
        },
    },
    watch: {
        params() {
            // this.page = +this.$route.query.page;
            this.init();
        },
    },
};
</script>